export default {
  home: {
    hero: {
      badge: '2026 Shopping Resource Hub',
      title: 'Your Complete Basetao Spreadsheet Resource',
      subtitle:
        'Find useful Basetao spreadsheets, product links, seller guides, QC tips and shipping help — organized in one clean place.',
      trust: 'Independent informational resource for Basetao shoppers.',
      categoryLabel: 'Browse by Category',
      categoryPlaceholder: 'Choose a category…',
    },
    categories: {
      title: 'Shop by Category',
      subtitle: 'Jump straight to the products you want on the main website.',
    },
    intro: {
      eyebrow: 'What is it',
      title: 'What is a Basetao Spreadsheet?',
      p1: 'A Basetao spreadsheet is an organized document that helps you track every product, seller, price and QC detail while shopping through the Basetao agent.',
      p2: 'It keeps your links, sizes, colors and shipping progress in one clean place, so you never lose track of an order or overspend by accident.',
    },
    features: {
      title: 'Everything you need to shop smarter',
      subtitle: 'From product links to final delivery, stay organized at every step.',
      items: [
        {
          title: 'Curated Categories',
          desc: 'Browse 14 product categories and jump straight to what you want.',
        },
        {
          title: 'Seller Guides',
          desc: 'Understand how to compare stores and pick trusted sellers.',
        },
        {
          title: 'QC Tips',
          desc: 'Know what to check before your items leave the warehouse.',
        },
        {
          title: 'Shipping Help',
          desc: 'Get familiar with shipping methods and cost basics.',
        },
      ],
    },
    articleTeaser: {
      eyebrow: 'Featured Guide',
      title: 'The Complete Basetao Spreadsheet Guide',
      desc: 'Learn how to build and use a Basetao spreadsheet to organize product links, sellers, QC photos and shipping details.',
      readMore: 'Read the full guide',
    },
    faq: {
      title: 'Frequently Asked Questions',
      items: [
        {
          q: 'What is Basetao Spreadsheet?',
          a: 'It is an informational resource that organizes product links, categories and shopping guides to help Basetao shoppers find what they need faster.',
        },
        {
          q: 'Do you sell products directly?',
          a: 'No. We link out to the main website where you can browse and buy the products.',
        },
        {
          q: 'Is this the official Basetao website?',
          a: 'No. This is an independent informational resource and is not the official Basetao website unless explicitly stated.',
        },
        {
          q: 'How do I use the category dropdown?',
          a: 'Open the dropdown, pick a category and you will be taken to the matching page on the main website.',
        },
      ],
    },
    finalCta: {
      title: 'Ready to explore Basetao Spreadsheet resources?',
      subtitle: 'Browse the categories below or visit the main website to start shopping.',
    },
  },
};